<template>
  <div>
    <!-- Message Notification -->
    <NotificationPopupMessage
      v-if="showMessage"
      :notification="notification"
      v-model="dialogVisible"
      @acknowledge="handleAcknowledge"
    />

    <!-- Component Notification --> 
    <!-- <v-dialog v-model="dialogVisible" persistent v-if="showComponent">
      <v-card>
        <v-card-text>
          <component
            :is="notification.data.component.name"
            v-bind="notification.data.component.props || {}"
            @close="handleClose"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="handleClose">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import NotificationPopupMessage from './NotificationPopupMessage.vue';

export default {
  name: 'PopupDispatcher',
  components: { NotificationPopupMessage },
  data() {
    return {
      notification: null,
      dialogVisible: false,
    };
  },
  computed: {
    showMessage() {
      return this.notification?.notification_type === 'message';
    },
    // showComponent() {
    //   return this.notification?.notification_type === 'component';
    // },
  },
  created() {
    this.$root.$on('trigger-popup', this.show);
  },
  methods: {
    async show(notification) {
      this.notification = notification;
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.notification = null;
    },
    handleAcknowledge(notification) {
      this.$store.dispatch('notifications/markRead', notification.notification_id);
      this.handleClose();
    }
  },
};
</script>
